import NotFound404 from '../components/ErrorPageComponent/404';
import SEO from '../components/SEO/SEO';
import { usePageSEO } from '../hooks/usePageSEO';

const ErrorPage = ({ hideHeaderFooterSetter }) => {
  const seo = usePageSEO('404');
  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        type={seo.type}
        noIndex={seo.noIndex}
        noFollow={seo.noFollow}
      />
      <NotFound404 hideHeaderFooterSetter={hideHeaderFooterSetter} />
    </>
  );
};

export default ErrorPage;